import { render, staticRenderFns } from "./ZDMFailuresAdmin.vue?vue&type=template&id=3b2828a4&scoped=true&"
import script from "./ZDMFailuresAdmin.vue?vue&type=script&lang=js&"
export * from "./ZDMFailuresAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2828a4",
  null
  
)

export default component.exports